import { BoldLabelText } from '@/components/BoldLabelText/BoldLabelText';
import { DescriptionCol, DescriptionRow } from '@/components/Description';
import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
  TransactionItemFormType,
} from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import { FormInput, Label } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './Placeholder.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  mode: TransactionItemDrawerMode;
};

export const Placeholder: FC<Props> = memo(({ mode }) => {
  const {
    control,
    formState: { errors },
    getValues,
  } = useFormContext<TransactionItemFormType>();

  const { t } = useTranslation();

  const placeholderRule = useMemo(() => {
    return {
      maxLength: {
        value: 20,
        message: t('transaction_items.validation_message.maxLength', {
          maxLength: 20,
        }),
      },
    };
  }, [t]);

  const placeholderNote = useMemo(() => {
    return (
      <div className={cx(styles['placeholder-caption'])}>
        {t('transaction_items.form.placeholder.note')}
      </div>
    );
  }, [t]);

  return (
    <DescriptionRow>
      <DescriptionCol
        label={
          <Label testId='placeholder_label'>
            <BoldLabelText>
              {t('transaction_items.form.placeholder')}
            </BoldLabelText>
            {mode !== TransactionItemDrawerModeEnum.DETAIL && placeholderNote}
          </Label>
        }
        labelWidth='176px'
      />
      <DescriptionCol
        value={
          <div className={cx(styles['container'])}>
            {mode === TransactionItemDrawerModeEnum.DETAIL ? (
              <div>{getValues('placeholder') ?? ''}</div>
            ) : (
              <>
                <div className={cx(styles['placeholder-container'])}>
                  <FormInput<TransactionItemFormType>
                    control={control}
                    name='placeholder'
                    inputId='placeholder'
                    rules={placeholderRule}
                    testId='placeholder'
                  />
                </div>
                {!errors.placeholder && (
                  <div className={cx(styles['placeholder-caption'])}>
                    {t('transaction_items.validation_message.maxLength.blank', {
                      maxLength: 20,
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        }
      />
    </DescriptionRow>
  );
});
Placeholder.displayName = 'Placeholder';
